// Mirror of Alphazzz-React-Frontend/constants/locations.js — keep the two in sync.
// Countries the mobile app serves and their prominent cities ("Other" = country only).
export const LOCATIONS = [
  { country: 'Pakistan', cities: ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar', 'Quetta', 'Hyderabad', 'Sialkot', 'Gujranwala', 'Wah Cantt'] },
  { country: 'Saudi Arabia', cities: ['Riyadh', 'Jeddah', 'Makkah', 'Madinah', 'Dammam', 'Khobar'] },
  { country: 'UAE', cities: ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah'] },
  { country: 'Qatar', cities: ['Doha', 'Al Rayyan', 'Al Wakrah'] },
  { country: 'Kuwait', cities: ['Kuwait City', 'Hawally', 'Salmiya'] },
  { country: 'Oman', cities: ['Muscat', 'Salalah', 'Sohar'] },
  { country: 'UK', cities: ['London', 'Manchester', 'Birmingham', 'Leeds', 'Glasgow', 'Bradford'] },
  { country: 'USA', cities: ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Dallas', 'San Francisco'] },
];

export const OTHER_CITY = 'Other';

// "Lahore, Pakistan" (just the country when the city is Other/empty).
export const composeLocation = (country, city) => {
  if (!country) return '';
  return city && city !== OTHER_CITY ? `${city}, ${country}` : country;
};
